// extracted by mini-css-extract-plugin
export default {"ProsList":"ProsList_ProsList__LvWPr"};